import "./base.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Models ??= {};

AppointmentBooking.Wizard.Models.VerifyIdAnswer = class VerifyIdAnswer extends AppointmentBooking.Wizard.Models.Base {};
